import React from 'react';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { ContinueUpload } from 'reactApp/ui/UploadBlock/ContinueUpload/ContinueUpload';
import { IUploadDropAreaProps, UploadDropArea } from 'reactApp/ui/UploadDropArea/UploadDropArea';
import { UploadListContainer } from 'reactApp/ui/UploadList/UploadList';

const newUploaderFeature = !EnvironmentSelectors.isMobile();

interface IProps extends IUploadDropAreaProps {
    allowUpload: boolean;
}

export const UploadBlock = ({ allowUpload = true, ...restProps }: IProps) => {
    return (
        <>
            {newUploaderFeature && <UploadListContainer allowUpload={allowUpload} />}
            {allowUpload && <UploadDropArea {...restProps} />}
            <ContinueUpload />
        </>
    );
};
